<div class="card mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Manage User</h5>
        </div>

        <form>
            <div class="row gy-4">
                <div class="field-group">
                    <label class="field-label" for="fullName">
                        Full name <span>*</span>
                    </label>
                    <input class="form-control" type="text" id="fullName" placeholder="Full name*" />
                </div>
                <div class="field-group">
                    <label class="field-label" for="fullName">
                        Email <span>*</span>
                    </label>
                    <input class="form-control" type="email" id="fullName" placeholder="Email*" />
                </div>
                <button type="submit" class="btn btn-get-started w-100">
                    Save
                </button>
            </div>
        </form>
    </div>
</div>

<div class="card mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Manage Company</h5>
        </div>

        <form>
            <div class="row gy-4">
                <div class="field-group">
                    <label class="field-label" for="fullName">
                        Full name <span>*</span>
                    </label>
                    <input class="form-control" type="text" id="fullName" placeholder="Full name*" />
                </div>
                <div class="field-group">
                    <label class="field-label" for="fullName">
                        Email <span>*</span>
                    </label>
                    <input class="form-control" type="email" id="fullName" placeholder="Email*" />
                </div>
                <button type="submit" class="btn btn-get-started w-100">
                    Save
                </button>
            </div>
        </form>
    </div>
</div>